module Elma.Bindings {

    export interface IRefreshPage {
        containerTarget: string
    }

    export class RefreshPage {

        // refresh page with ajax
        // update custom html container (class or id) with new html

        private updateValues = (element: any, valueAccessor: () => IRefreshPage, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) => {

            if (!bindingContext) {
                return;
            }

            var value = ko.unwrap(valueAccessor());
            var $elm = $(element);
            var targetURL = $elm.attr("href");

            if (targetURL) {
                $elm.on("click", function updateHTML(e: Event) {

                    e.preventDefault(); // stop click event

                    var containerTarget = value.containerTarget;
                    var nextURL, prevURL, nextText, prevText;

                    $.get(targetURL, function loadAchieved(data) {
                        if (data) {
                            var $updatedContainer = $(data).find(containerTarget);
                            if ($updatedContainer.length) {
                                $(containerTarget).html($updatedContainer.html());

                                // special use for related products
                                var $closestProductsParent = $elm.closest(".js-related-products-parent");

                                if ($closestProductsParent.find("#js-load-more-info")) {
                                    var loadMoreObj = $elm.closest(".js-related-products-parent").find("#js-load-more-info");
                                    if (loadMoreObj) {
                                        nextURL = loadMoreObj.attr("data-next-url");
                                        prevURL = loadMoreObj.attr("data-previous-url");
                                        nextText = loadMoreObj.attr("data-next-text");
                                        prevText = loadMoreObj.attr("data-previous-text");

                                        if (nextURL) {
                                            targetURL = nextURL;
                                            $elm.text(nextText);
                                        } else if (prevURL) {
                                            targetURL = prevURL;
                                            $elm.text(prevText); // update text only after reload;
                                        }
                                    }

                                }
                                // end of special use for related products
                            }
                        }
                    });
                });
            }

        };

        public init = this.updateValues;
        public update = this.updateValues;

    }

    ko.bindingHandlers['refreshPage'] = new RefreshPage();

}